import config from '@app/config';
import { fetchGetSeoDataApiDto } from '@entities/Seo/module/services/api.dto';
import { seoDataType } from '@entities/Seo/module/types/seoSchema';
import { defaultHeaders } from '@redux/api/Config';
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';
import { sendSentrySeoInfo } from '@entities/Seo/module/helpers/sendSentrySeoInfo';

function isHydrateAction(action: Action): action is PayloadAction<any> {
  return action.type === HYDRATE;
}

export const seoApi = createApi({
  reducerPath: 'seoApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.baseApiUrl,
    prepareHeaders: defaultHeaders,
  }),
  extractRehydrationInfo(action, { reducerPath }): any {
    if (isHydrateAction(action)) {
      return action.payload[reducerPath];
    }
  },
  endpoints: builder => ({
    getSeoPage: builder.query<seoDataType, fetchGetSeoDataApiDto>({
      query: ({ regionId, slug }) => {
        return `/api/catalog/seo?regionId=${regionId}&page=${encodeURIComponent(slug.replaceAll('&', ':'))}`;
      },
      transformResponse: (response: { data: seoDataType }, meta, arg) => {
        const data = response.data;
        const url = `/api/catalog/seo?regionId=${arg.regionId}&page=${encodeURIComponent(arg.slug.replaceAll('&', ':'))}`;
        sendSentrySeoInfo(url, data, 'client');

        return data;
      },
    }),
  }),
});

export const { useGetSeoPageQuery, endpoints: seoEndpoints } = seoApi;
